import './myEvaluationList.scss';
import UserService from '../../user/services/userService';
import DateFormatFilter from '../../../filters/dateFormat';
import MyEvaluationListController from "./myEvaluationListController";
import EvaluationService from "../../evaluation/services/evaluationService";
import ListService from "../services/listService";

const MyEvaluationListComponent = {
    template: require('./myEvaluationListView.html'),
    controller: MyEvaluationListController
};

export default angular.module('app.myevaluationlist', [require('angular-material-data-table')])
    .component('myevaluationlist', MyEvaluationListComponent)
    .filter('dateFormat', DateFormatFilter)
    .service('EvaluationService', EvaluationService)
    .service('ListService', ListService)
    .service('UserService', UserService)
    .name;



// WEBPACK FOOTER //
// ./src/app/pages/lists/myEvaluationList/myEvaluationListComponent.js